import Vue from 'vue'
import Clipboard from 'vue-clipboard2'

Vue.use(Clipboard)
